import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import { getWalletHistory } from "../../services/paymentManagement.services";

const WalletHistory = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(parseInt(params.pgno) || 1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});

  const getEarningSource = (row) => {
    if (!row.reference_type) return row.purpose || "N/A";
    const refType = row.reference_type.toLowerCase();
    if (refType === "booking") return "Puja";
    if (
      refType === "consultation_booking" ||
      ["chat", "call", "video"].includes(refType)
    )
      return "Consultation";
    if (refType === "report_booking") return "Report";
    if (refType === "question_booking") return "Question";
    return refType.charAt(0).toUpperCase() + refType.slice(1);
  };

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Wallet History"), url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const payload = {
        page: params.pgno || 1,
        per_page: itemperpage,
        global_search: globalsearch,
        ...search,
      };

      getWalletHistory(payload)
        .then((res) => {
          if (res.success) {
            setList(res.data.list || []);
            setDataLength(res.data.total_records || 0);
            setPage(res.data.page || 1);
          }
          setLoader(false);
        })
        .catch((error) => {
          console.error(error);
          setLoader(false);
        });
    }, 500);
    return () => clearTimeout(getData);
  }, [location, search, globalsearch, itemperpage, params.pgno]);

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
  };

  const handleViewDetails = (id) => {
    navigate(`/admin/payment-management/view/wallet/${id}`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Wallet History")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="input-group">
                    <span className="input-group-text bg-transparent border-end-0">
                      <i className="fa fa-search text-muted"></i>
                    </span>
                    <input
                      type="search"
                      className="form-control border-start-0 ps-0"
                      value={globalsearch}
                      placeholder={t("Search by ID, Desc...")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                {/* <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => setSearch({ ...search, start_date: e.start, end_date: e.end })}
                                        resetdate={resetdate}
                                    />
                                </div> */}
                <button onClick={resetFilter} className="btn btn-warning">
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>{t("list_heading_sno")}</th>
                    <th>{t("Order Number")}</th>
                    <th>{t("User")}</th>
                    <th>{t("Astrologer")}</th>
                    <th>{t("User Type")}</th>
                    <th>{t("Type")}</th>
                    <th>{t("Amount")}</th>
                    <th>{t("Admin Commission")}</th>
                    <th>{t("Global Discount")}</th>
                    <th>{t("Purpose")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Created Date")}</th>
                    <th>{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={13}>
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length > 0 ? (
                    list.map((row, i) => (
                      <tr key={i}>
                        <td>{(page - 1) * itemperpage + i + 1}</td>
                        <td className="fw-bold text-primary">{row.order_number || `WAL-${row.id}`}</td>
                        <td>{row.user?.name || "N/A"}</td>
                        <td>
                          {row.associated_astrologer?.name ||
                            row.astrologer?.name ||
                            "N/A"}
                        </td>
                        <td>
                          <span
                            className={`badge text-capitalize bg-${row.user_type === "admin" ? "warning text-dark" : row.user_type === "astrologer" ? "info" : "primary"}`}
                          >
                            {row.user_type === "admin"
                              ? t("Admin")
                              : row.user_type === "astrologer"
                                ? t("Astrologer")
                                : t("User")}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge bg-${row.type === "credit" ? "success" : "danger"}`}
                          >
                            {row.type}
                          </span>
                        </td>
                        <td>
                          {row.currency_type === "USD" ? "$" : "₹"}
                          {parseFloat(row.amount).toFixed(2)}
                        </td>
                        <td className="fw-bold text-danger">
                          {row.user_type === "admin" ? (
                            "-"
                          ) : row.admin_commission_amount ? (
                            <>
                              {"₹" +
                                parseFloat(row.admin_commission_amount).toFixed(
                                  2,
                                )}
                              {row.admin_commission_percentage !== null && (
                                <span
                                  className="text-muted fw-normal ms-1"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  ({row.admin_commission_percentage}%)
                                </span>
                              )}
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {row.global_discount
                            ? `${parseFloat(row.global_discount).toFixed(2)}%`
                            : "-"}
                        </td>
                        <td>{getEarningSource(row)}</td>
                        <td>
                          <span
                            className={`badge bg-${row.status === "success" ? "success" : row.status === "pending" ? "warning" : "danger"}`}
                          >
                            {row.status}
                          </span>
                        </td>
                        <td>
                          {row.createdAt
                            ? formateDateWithMonth(row.createdAt)
                            : "N/A"}
                        </td>
                        <td>
                          <button
                            className="btn ripple btn-main-primary signbtn"
                            onClick={() => handleViewDetails(row.id)}
                          >
                            {t("btn_view")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        {t("msg_no_records")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-3">
              <b>
                {t("msg_total_records")} : {datalength}
              </b>
            </div>

            {datalength > 0 && (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={(p) =>
                  navigate(`/admin/payment-management/wallet-history/${p}`)
                }
                pageRoute={[
                  {
                    name: "Wallet History",
                    path: "/admin/payment-management/wallet-history",
                  },
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletHistory;
